// extracted by mini-css-extract-plugin
module.exports = {"Fourth":"Fourth_Fourth__9UuS5"};